// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox__1p0b9","check":"check__3fX_3","label":"label__1syVX","box":"box__27LQ8","active":"active__25bjv"};